import { createSlice } from '@reduxjs/toolkit';
import { addStudyTopicApi } from '../../../rtk-apis/reports/addStudyTopicApi';

const initialState = {
  status: '',
  data: '',
  msg: '',
  loading: false,
};

const addStudyTopicSlice = createSlice({
  name: 'addStudyTopic',
  initialState,
  reducers: {
    clearTopicState: state => {
      state.status = '';
      state.data = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(addStudyTopicApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addStudyTopicApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data;
        state.msg = action?.payload?.msg;
      })
      .addCase(addStudyTopicApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = '';
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default addStudyTopicSlice.reducer;
export const { clearTopicState } = addStudyTopicSlice.actions;
